import { render, staticRenderFns } from "./SpacesEditorToolbarListButton.vue?vue&type=template&id=0867483f&scoped=true"
import script from "./SpacesEditorToolbarListButton.js?vue&type=script&lang=js&external"
export * from "./SpacesEditorToolbarListButton.js?vue&type=script&lang=js&external"
import style0 from "./SpacesEditorToolbarListButton.scss?vue&type=style&index=0&id=0867483f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0867483f",
  null
  
)

export default component.exports